// extracted by mini-css-extract-plugin
export default {"non_button":"Footer_non_button__VwjJC"};